export const GET_CLIENT_SUMMARY_LBS = 'GET_CLIENT_SUMMARY_LBS';
export const GET_CLIENT_SUMMARY_LBS_SUCCESS = 'GET_CLIENT_SUMMARY_SUCCESS';
export const SAVE_CLIENT_SUMMARY_LBS = 'SAVE_CLIENT_SUMMARY_LBS';
export const CLIENT_SUMMARY_LBS_ERROR = 'CLIENT_SUMMARY_LBS_ERROR';
